import { useStripe } from '@stripe/react-stripe-js';
import { useFirestore } from './useFirestore';

export const useStripePayment = () => {
  const stripe = useStripe();
  const { createDocument } = useFirestore();

  const handlePayment = async (paymentData) => {
    const { clientSecret } = await createDocument('payments', paymentData);
    const result = await stripe.confirmCardPayment(clientSecret);

    if (result.error) {
      console.log(result.error.message);
    } else {
      if (result.paymentIntent.status === 'succeeded') {
        console.log('Payment succeeded!');
      }
    }
  };

  return {
    handlePayment,
  };
};
